module.exports = __webpack_public_path__ + "img/optmint_foot.f824d693.png";